export default __webpack_public_path__ + "static/media/726.df7de2ce.png";